import {KPIGrid} from 'constants/url';
import useLoadPost from 'components/hooks/useLoadPost';

function useLoadKPI(additional) {
  return useLoadPost(KPIGrid, 'iD_Course', additional);
}
export default useLoadKPI;
